// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  tradeId: __t.u64().primaryKey().name("trade_id"),
  a: __t.identity(),
  b: __t.identity(),
  state: __t.string(),
  rev: __t.u32(),
  offerA: __t.string().name("offer_a"),
  offerB: __t.string().name("offer_b"),
  sovA: __t.i64().name("sov_a"),
  sovB: __t.i64().name("sov_b"),
  confirmA: __t.u32().name("confirm_a"),
  confirmB: __t.u32().name("confirm_b"),
  result: __t.string(),
  expiresAt: __t.timestamp().name("expires_at"),
  at: __t.timestamp(),
  updatedAt: __t.timestamp().name("updated_at"),
});
